import { Injectable, EventEmitter} from '@angular/core';
import {TransferState, makeStateKey, StateKey} from '@angular/platform-browser';
import { GoogleAds, LandingModel} from '../model/landingModel';
import { Module } from '../model/ModuleModel';

@Injectable()
export class LandingModelService {
    protected static LANDING_MODEL_KEY: StateKey<LandingModel> = makeStateKey<LandingModel>('landingModel');
    public modulesUpdatedEvent: EventEmitter<Module[]> = new EventEmitter();

    private landingModelData: LandingModel;

    constructor(private transferState: TransferState) {
    }

    getLandingModel(): LandingModel {
        if (this.landingModelData == null) {
            this.landingModelData = this.transferState.get<LandingModel>(LandingModelService.LANDING_MODEL_KEY, null!);
        }
        return this.landingModelData;
    }

    getLocale(): string {
        return `${this.landingModelData?.language?.toLowerCase()}_${this.landingModelData?.country?.toUpperCase()}`;
    }

    updateModules(modules: Module[]) {
        this.landingModelData.modules = modules;
        this.modulesUpdatedEvent.emit(this.landingModelData.modules);
    }

    updateGoogleAds(googleAds: GoogleAds) {
        this.landingModelData.googleAds = googleAds;
    }

    isCachedLanding(): boolean {
        return this.landingModelData.isCachedVersion;
    }
}
